import React from 'react';

const LineSeparator = () => <hr style={{ margin: '50px', width: 'calc(100% - 100px)' }} />;

export default LineSeparator;
